import SurveyTemplate from '@/models/SurveyTemplate';

const GET_SURVEY_TEMPLATE = 'get_survey_template';
const GET_SURVEY_TEMPLATE_REQUEST = 'get_survey_template_request';
const GET_SURVEY_TEMPLATE_SUCCESS = 'get_survey_template_success';
const GET_SURVEY_TEMPLATE_ERROR = 'get_survey_template_error';

const SAVE_SURVEY_TEMPLATE = 'save_survey_template';
const SAVE_SURVEY_TEMPLATE_REQUEST = 'save_survey_template_request';
const SAVE_SURVEY_TEMPLATE_SUCCESS = 'save_survey_template_success';
const SAVE_SURVEY_TEMPLATE_ERROR = 'save_survey_template_error';


const SAVE_SURVEY_TEMPLATE_QUESTION = 'save_survey_template_question';
const SAVE_QUESTION = 'save_question_mutation';

const DELETE_SURVEY_TEMPLATE_QUESTION = 'delete_survey_template_question';
const DELETE_QUESTION = 'delete_question_mutation';

const MOVE_QUESTION_UP = 'move_question_up';
const MOVE_QUESTION_DOWN = 'move_question_down';

const SURVEY_TEMPLATE_TYPES = ['client', 'employer'];
const SURVEY_TEMPLATE_QUESTION_TYPES = ['open', 'scale', 'multiple', 'likert'];

export {
    GET_SURVEY_TEMPLATE,
    SURVEY_TEMPLATE_TYPES,
    SAVE_SURVEY_TEMPLATE,
    SURVEY_TEMPLATE_QUESTION_TYPES,
    SAVE_SURVEY_TEMPLATE_QUESTION,
    DELETE_SURVEY_TEMPLATE_QUESTION,
    MOVE_QUESTION_UP,
    MOVE_QUESTION_DOWN,
};

export default {
    state: {
        template: {
            questions: []
        },
        loading: false,
        templateErrors: [],
    },
    mutations: {
        [GET_SURVEY_TEMPLATE_REQUEST]: (state) => {
            state.template = {};
            state.loading = true;
            state.templateErrors = [];
        },
        [GET_SURVEY_TEMPLATE_SUCCESS]: (state, { template }) => {
            state.template = template;
            state.loading = false;
            state.templateErrors = [];
        },
        [GET_SURVEY_TEMPLATE_ERROR]: (state, { errors }) => {
            state.template = {
                questions: []
            };
            state.loading = false;
            state.templateErrors = errors;
        },
        [SAVE_SURVEY_TEMPLATE_REQUEST]: (state) => {
            state.loading = true;
            state.templateErrors = [];
        },
        [SAVE_SURVEY_TEMPLATE_SUCCESS]: (state, { template }) => {
            state.template = template;
            state.loading = false;
            state.templateErrors = [];
        },
        [SAVE_SURVEY_TEMPLATE_ERROR]: (state, { errors }) => {
            state.loading = false;
            state.templateErrors = errors;
        },
        [SAVE_QUESTION]: (state, { question }) => {
            if (question.id) {
                let questionIndex = state.template.questions.findIndex(q => q.id === question.id);
                state.template.questions[questionIndex] = question;
            } else {
                state.template.questions.push(question);
            }
        },
        [DELETE_QUESTION]: (state, { question }) => {
            const index = state.template.questions.indexOf(question);
            state.template.questions.splice(index, 1);
        },
        [MOVE_QUESTION_UP]: (state, { question }) => {
            const index = state.template.questions.indexOf(question);
            let questions = state.template.questions;
            state.template.questions = [
                ...questions.slice(0, index - 1),
                questions[index],
                questions[index - 1],
                ...questions.slice(index + 1)
            ];
        },
        [MOVE_QUESTION_DOWN]: (state, { question }) => {
            const index = state.template.questions.indexOf(question);
            let questions = state.template.questions;
            state.template.questions = [
                ...questions.slice(0, index),
                questions[index + 1],
                questions[index],
                ...questions.slice(index + 2)
            ];
        }
    },
    actions: {
        [GET_SURVEY_TEMPLATE]: ({ commit, state }, { id = state.template.id }) => {
            commit(GET_SURVEY_TEMPLATE_REQUEST);
            return new Promise((resolve, reject) => {
                SurveyTemplate.document(id)
                    .then(template => {
                        commit(GET_SURVEY_TEMPLATE_SUCCESS, { template });
                        resolve(template);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_SURVEY_TEMPLATE_ERROR, { errors });
                        reject(({ status, errors }));
                    });
            });
        },
        [SAVE_SURVEY_TEMPLATE]: ({ commit, state }, { template = state.template }) => {
            commit(SAVE_SURVEY_TEMPLATE_REQUEST);
            return new Promise((resolve, reject) => {
                template.save()
                    .then(template => {
                        commit(SAVE_SURVEY_TEMPLATE_SUCCESS, { template });
                        resolve(template);
                    })
                    .catch(({ status, errors }) => {
                        commit(SAVE_SURVEY_TEMPLATE_ERROR, { errors });
                        reject(({ status, errors }));
                    });
            });
        },
        [SAVE_SURVEY_TEMPLATE_QUESTION]: ({ dispatch, commit }, { question }) => {
            commit(SAVE_QUESTION, { question });
            return dispatch(SAVE_SURVEY_TEMPLATE, {});
        },
        [DELETE_SURVEY_TEMPLATE_QUESTION]: ({ dispatch, commit }, { question }) => {
            commit(DELETE_QUESTION, { question });
            return dispatch(SAVE_SURVEY_TEMPLATE, {});
        },
    },
    getters: {
        isFirstQuestion: state => question => {
            return state.template.questions.indexOf(question) === 0;
        },
        isLastQuestion: state => question => {
            return state.template.questions.indexOf(question) === state.template.questions.length - 1;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/survey-template.js